// extracted by mini-css-extract-plugin
export default {"second":"second_second__l4yYm","next-gen":"second_next-gen__kMY6M","next-gen-text":"second_next-gen-text__4Cf5S","img":"second_img__-A2mJ","_1":"second__1__fz-N9"};